// Autogenerated file
export const parallelPointBehaviorsEnum = {
    Update: "Update",
    Delete: "Delete",
};
export const parallelPointBehaviors = [
    { label: "Обновить точку перецепки в другой заявке", value: "Update" },
    { label: "Удалить точку перецепки в двух заявках", value: "Delete" },
];
